import { updateTemplate } from '@/api/services/templates';
import { DifficultyLevel } from '@/components/Template/types';
import { AxiosError } from 'axios';

type HandleTemplateUpdateParams = {
  templateId: string;
  name: string;
  description: string;
  difficulty: DifficultyLevel;
  items: any;
  onSuccess: () => void;
  showNotification: (options: {
    type: 'success' | 'error';
    title: string;
    message: string;
  }) => void;
};

export const handleTemplateUpdateUtil = async ({
  templateId,
  items,
  name,
  description,
  difficulty,
  showNotification,
  onSuccess,
}: HandleTemplateUpdateParams): Promise<boolean> => {
  try {
    await updateTemplate(templateId, { name, description, difficulty, items });
    showNotification({
      type: 'success',
      title: `Die Vorlage ${name} wurde gespeichert.`,
      message: '',
    });
    onSuccess();
    return true;
  } catch (error) {
    const axiosError = error as AxiosError<any>;
    showNotification({
      type: 'error',
      title: axiosError.response?.data?.message?.includes('duplicate')
        ? 'Vorlage mit diesem Namen existiert bereits'
        : 'Fehler beim Speichern der Vorlage',
      message: '',
    });
    return false;
  }
};
